import { useRef, useEffect, useState } from 'react';
import { X } from 'lucide-react';
import ChatBox from './ChatBox';

export default function LiveChatModal({ isOpen, onClose }) {
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        if (isOpen) {
            dialog.showModal();
        } else {
            dialog.close();
        }
    }, [isOpen]);

    const handleClose = () => {
        onClose();
    };

    return (
        <dialog
            ref={dialogRef}
            className="backdrop:bg-black/50"
            style={{ width: '50%' }}
        >
            <style>{`
                dialog button.p-2 {
                display: none;
                }
            `}</style>
            <button
                onClick={handleClose}
                className="outline-none absolute top-4 right-4 z-10 text-gray-400 hover:text-white hover:bg-purple-700 rounded-lg transition-colors"
                style={{ margin: '6px' }}
            >
                <X size={36} />
            </button>
            <ChatBox />
        </dialog>
    );
}